export default {
    render(data, event, container) {
        const element = document.createElement('span');
        if (data.userValue) {
            element.innerText = container.componentList.FirebaseStorage.data()[data.userValue];
        }

        if (data.t) {
            if (LanguageManager.getString(data.t)) {
                element.innerText = LanguageManager.getString(data.t);
            } else {
                element.innerText = '[[text|translationMissing]]';
            }
        }
        return element;
    }
}